const filterConstantsToSend = (selected, list) => Object.fromEntries(selected.map((key) => [key, list[key]]));
const formatString = (title) => {
  if (title?.trim() === "*") {
    return "";
  }
  return title?.split(" ").join("-").toLowerCase().normalize("NFD").replace(/[\u0300-\u036F]/g, "").replace(/[^\dA-Za-z-]+/g, "");
};
const formatNumberToString = (value) => Number.parseInt(value, 10).toString();
const getProgressPercentage = (progress, duration) => {
  const progressPercentage = progress * 100 / duration;
  return Math.round(progressPercentage);
};
const getChangeProgress = (progress, startProgress) => {
  const changeProgress = progress - startProgress;
  return Math.round(changeProgress)?.toString();
};
const removeUndefinedFromObject = (object) => {
  const filteredObject = {};
  for (const key of Object.keys(object)) {
    if (object[key] !== void 0 && object[key] !== null) {
      filteredObject[key] = object[key];
    }
  }
  return filteredObject;
};
const formatDataToSend = ({ userData, assetData }) => {
  try {
    const {
      content,
      subtitleTrack,
      searchTerms,
      audioTrack,
      text,
      errorCode,
      sectionName,
      listPosition,
      transmissionType,
      providerName,
      collectionName,
      verticalScrollPercent,
      errorType,
      campaignName,
      isKids,
      askSecurityCode,
      pageReferral,
      componentType,
      groupId,
      matchId,
      teamId,
      playOff,
      sectionId,
      planId,
      timestamp,
      filterEpg,
      filterMiniEpg,
      isSports,
      tab,
      cancelMotive,
      ratingServices,
      couponActivated,
      filterPdp,
      seriePosition,
      timeOnePage,
      timeToStart,
      playerType,
      verticalPositionCarousel,
      api
    } = assetData;
    let formattedContent = {};
    const startProgressBarFormattedValue = formatNumberToString(content?.startProgressBar);
    const changeProgressCalc = getChangeProgress(content?.progress, content?.startProgressBar);
    const percentualCalculation = getProgressPercentage(content?.progress, content?.duration);
    formattedContent = {
      /* CUSTOM DIMENSIONS */
      v_content_name: formatString(content?.title),
      v_content_type: formatString(content?.type),
      v_content_id: content?.vrioAssetId,
      v_genre: formatString(content?.genre),
      v_play_source: formatString(content?.playSource),
      v_start_progress_bar: startProgressBarFormattedValue,
      v_channel_name: formatString(content?.channelName),
      v_serie_name: formatString(content?.serieName),
      v_season: content?.episode?.seasonNumber?.toString(),
      v_search_terms: formatString(searchTerms),
      v_video_subtitle: subtitleTrack,
      v_video_language: audioTrack,
      v_text: formatString(text),
      v_error_code: formatString(errorCode),
      v_api: api?.toString(),
      v_section_name: formatString(sectionName),
      v_list_position: listPosition?.toString(),
      v_tab: formatString(tab),
      v_transmission_type: transmissionType,
      v_provider_name: formatString(providerName),
      v_collection_name: formatString(collectionName),
      v_content_locked: content?.contentLocked?.toString(),
      v_error_type: formatString(errorType),
      v_campaign_name: formatString(campaignName),
      v_is_kids: isKids?.toString(),
      v_ask_security_code: askSecurityCode?.toString(),
      v_page_referral: formatString(pageReferral),
      v_component_type: formatString(componentType),
      v_vertical_scroll_percent: verticalScrollPercent?.toString(),
      v_group_id: groupId?.toString(),
      v_match_id: matchId?.toString(),
      v_team_id: teamId?.toString(),
      v_playoff: formatString(playOff),
      v_section_id: sectionId?.toString(),
      v_plan_id: planId?.toString(),
      v_channel_id: content?.channelId?.toString(),
      v_timestamp: timestamp?.toString(),
      v_episode_number: content?.episode?.episodeNumber?.toString(),
      v_content_player_type: formatString(playerType),
      v_primary_genre: formatString(content?.primaryGenre),
      v_episode_name: formatString(content?.episode?.episodeName),
      v_filter_epg: formatString(filterEpg),
      v_change_progress: changeProgressCalc,
      v_finish_progress_bar: changeProgressCalc,
      v_filter_miniepg: formatString(filterMiniEpg),
      v_is_sports: isSports?.toString(),
      v_cancel_motive: formatString(cancelMotive),
      v_rating_services: formatString(ratingServices),
      v_coupon_activated: formatString(couponActivated),
      v_filter_pdp: formatString(filterPdp),
      v_vertical_position_carousel: verticalPositionCarousel?.toString(),
      v_content_age_rating: formatString(content?.contentAgeRating),
      v_age_restricted_content: formatString(content?.ageRestrictedContent),
      v_change_parental_control: formatString(content?.changeParentalControl),
      v_is_betting: formatString(content?.isBetting),
      /* CUSTOM METRICS */
      v_video_duration: content?.duration,
      v_finish_progress_percentual: percentualCalculation,
      v_serie_position: seriePosition,
      v_time_one_page: timeOnePage,
      v_start_video_percentual: percentualCalculation,
      v_change_progress_percentual: percentualCalculation,
      v_time_to_start: timeToStart
    };
    return {
      ...userData,
      ...formattedContent
    };
  } catch (error) {
    console.error(`An error occurred generating content for GTM: ${error.message}`);
    return void 0;
  }
};

export { filterConstantsToSend, formatDataToSend, formatNumberToString, formatString, getChangeProgress, getProgressPercentage, removeUndefinedFromObject };
//# sourceMappingURL=utils.js.map
